import TEXT from './generated/TEXT/sharedStrings';

TEXT.DEFINE({
  /** Message shown when the selection exceeds the supported limit for this action. */
  tooManySelectedText: ({
    actionName,
    assetCount = 100,
  }: {
    actionName: string;
    assetCount?: number;
  }): string =>
    `${actionName} can be applied to up to ${assetCount} assets at a time.`,
  /** Message shown when we fail to start the remove background generation. */
  errorMessageToast: ({ actionName }: { actionName: string }): string =>
    `There was an error starting the ${actionName} generation.`,
});

export const SHARED_TEXT = TEXT;
